import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { provideApplicationBarItemType } from "@common/shell/application-bar/application-bar.component";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { ApplicationBarCoachChatItem } from "./application-bar-coach-chat-item/application-bar-coach-chat-item";
import { ApplicationBarCoachChatItemComponent } from "./application-bar-coach-chat-item/application-bar-coach-chat-item.component";
import { CoachChatPageComponent, coachChatPageRoute } from "./coach-chat-page/coach-chat-page.component";


@NgModule({
    imports: [
        CommonModule,
        AdaptButtonModule,
    ],
    declarations: [
        ApplicationBarCoachChatItemComponent,
        CoachChatPageComponent,
    ],
    providers: [
        provideApplicationBarItemType(ApplicationBarCoachChatItem),
    ],
})
export class AdaptCoachChatModule {
    public static readonly Routes = [
        ...coachChatPageRoute.routes,
    ];
}
